import React from 'react';
import { Switch } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const SwitchLabel = ({
  label,
  labelPos = 'right',
  className,
  switchClassName,
  ...props
}) => {
  return (
    <div className={cn(styles.root, className)}>
      {label && labelPos === 'left' && label}
      <Switch {...props} className={cn(styles.switch, switchClassName)} />
      {label && labelPos === 'right' && label}
    </div>
  );
};

export default SwitchLabel;
